import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import PowerBIForm from './PowerBIForm';
import PowerBIDashboard from './PowerBIDashboard';
import { injectIntl } from 'react-intl';
import apiService from 'src/services/apiService';

const PowerBIScreen = ({ intl }) => {
  const [workspaceId, setWorkspaceId] = useState('');
  const [instance, setInstance] = useState<PublicClientApplication | null>(
    null,
  );
  const [showBI, setShowBI] = useState(false);

  const getMsalInstance = () => {
    const msalConfig = {
      auth: {
        clientId: '7f6b1e3a-3936-4920-8eca-5e8993d2e6a7',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
      },
    };

    return new PublicClientApplication(msalConfig);
  };

  useEffect(() => {
    const newInstance = getMsalInstance();
    setInstance(newInstance);

    const getWorkspaceId = async () => {
      const localToken = localStorage.getItem('token');
      await apiService
        .get('/user/workspace_id', {
          headers: { Authorization: `Bearer ${localToken}` },
        })
        .then(response => {
          const data = response.data;

          if (data.workspace_id !== null) {
            setWorkspaceId(data.workspace_id);
            setShowBI(true);
          }
        })
        .catch(error => {
          console.error(error);
          setShowBI(false);
        });
    };
    getWorkspaceId();
  }, []);

  return showBI && instance && workspaceId ? (
    <MsalProvider instance={instance}>
      <PowerBIDashboard
        workspaceId={workspaceId}
        intl={intl}
        setShowBI={setShowBI}
      />
    </MsalProvider>
  ) : (
    <PowerBIForm intl={intl} />
  );
};

export default injectIntl(PowerBIScreen);
